import React, { BaseSyntheticEvent, FC } from 'react'

import { Typography, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { isSameDay } from 'date-fns'

import { CalendarCellProps } from './type'

export const CalendarCellWrapper: FC<CalendarCellProps> = ({
  date,
  bgColor,
  children,
  setDateForModal,
}) => {
  const { spacing, palette } = useTheme()

  const isToday = isSameDay(date, new Date())

  const handleDate = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    if (bgColor) {
      setDateForModal && setDateForModal(date)
    }
  }

  return (
    <Box
      height={{ xs: spacing(6), sm: spacing(8) }}
      bgcolor={bgColor}
      display="flex"
      flexDirection="column"
      p={{ xs: spacing(0.5), sm: spacing(1) }}
      onClick={handleDate}
      sx={{
        '&:hover': {
          cursor: bgColor ? 'pointer' : 'unset',
        },
        borderBottom: isToday ? `${spacing(0.5)} solid ${palette.primary.main}` : '',
      }}
    >
      <Typography
        color={isToday ? palette.primary.main : palette.text.secondary}
        fontSize={{ xs: 9, sm: 10 }}
        lineHeight={1}
        fontWeight={500}
        textAlign="start"
      >
        {date.getDate()}
      </Typography>
      <Box display={'flex'} flexDirection={'column'} height={'100%'} justifyContent={'center'}>
        {children}
      </Box>
    </Box>
  )
}
